var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useEntityLayout } from '../hooks/use-entity-layout';
import { useEntityTypePageQuery } from '../hooks/use-entity-type-page-query';
import { EntityProvider } from '../context/entity-context';
import { PageEntityProvider } from '../context/page-entity-context';
import { ActiveEntityTypeProvider } from '../context/active-entity-type-context';
var cls = classNames('entity-details-route');
export var EntityDetailsRouteDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme.COLOR('app-chrome'))
});
// -------- Components -------->
var My = {
  NAME: 'EntityDetailsRoute',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var EntityDetailsRoute = function (props) {
  var componentProps = useComponentProps(My.NAME, EntityDetailsRouteDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    slug = componentProps.slug,
    entityTypeName = componentProps.entityTypeName;
  var Layout = useEntityLayout(entityTypeName);
  var _a = useEntityTypePageQuery(entityTypeName, slug),
    entity = _a.entity,
    loading = _a.loading;
  return React.createElement(ActiveEntityTypeProvider, {
    value: entityTypeName
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(EntityProvider, {
    value: entity
  }, React.createElement(PageEntityProvider, {
    value: entity
  }, React.createElement(Layout, {
    entity: entity,
    loading: loading
  })))));
};
EntityDetailsRoute.cls = cls;
var templateObject_1, templateObject_2;